import type { FooterContent } from '../types/FooterContent';

export function createFooterContentPlaceholder(): FooterContent {
    return {
        left: {
            title: { kind: 'plainText', key: '', content: '' },
            links: {
                kind: 'linkCollection',
                key: '',
                links: [],
            },
        },
        right: {
            title: { kind: 'plainText', key: '', content: '' },
            links: {
                kind: 'linkCollection',
                key: '',
                links: [],
            },
        },
        bottom: {
            connect: {
                title: { kind: 'plainText', key: '', content: '' },
                links: {
                    kind: 'imageLinkCollection',
                    key: '',
                    links: [],
                },
            },
            copyrightNotice: {
                copyright: { kind: 'plainText', key: '', content: '' },
                rightsNotice: { kind: 'plainText', key: '', content: '' },
            },
            links: {
                kind: 'linkCollection',
                key: '',
                links: [],
            },
        },
    };
}
